module.exports = __webpack_public_path__ + "static/media/handbooklink.6751c20c.png";